import { format, toZonedTime } from 'date-fns-tz';
import { TZDate } from 'react-day-picker';

export const formatDateToTimezone = (
  date: Date | string,
  timeZone: string,
  formatString?: string,
) => {
  if (!date) return '';
  try {
    const dateObj = typeof date === 'string' ? new Date(date) : date;
    if (Number.isNaN(dateObj.getTime())) return '';

    const convertDate = toZonedTime(dateObj, timeZone);
    return format(convertDate, formatString ?? 'yyyy-MM-dd hh:mm:ss', {
      timeZone: timeZone,
    });
  } catch (error) {
    return '';
  }
};

export const convertDateToTimezone = (date: Date, timeZone: string) => {
  const convertDate = new TZDate(date, timeZone);
  return convertDate;
};

export const getNewDate = (timeZone?: string | null) => {
  return timeZone ? new TZDate(new Date(), timeZone) : new Date();
};

export function getGMTOffsetByTimezone(timezone: string) {
  try {
    const formatter = new Intl.DateTimeFormat('en-US', {
      timeZone: timezone,
      hour12: false,
      timeZoneName: 'longOffset',
    });

    const parts = formatter.formatToParts(getNewDate(timezone));

    const offsetPart = parts.find((part) => part.type === 'timeZoneName');

    if (!offsetPart) return 'Invalid Timezone';

    const offset = offsetPart.value.replace('UTC', 'GMT');

    // Ensure offset is always in (GMT±HH:MM) format
    /*
    /([+-])(\d)$/ → This is a regular expression (regex):
    ([+-]) → Matches the + or - sign (indicating the offset direction).
    (\d)$ → Matches a single digit (a single-digit hour, like GMT+9 or GMT-5).
    "$10$2:00" → This formats the offset as GMT±0H:00:
    $1 → Inserts the + or - sign.
    0$2 → Adds a 0 before the single-digit hour.
    :00 → Adds :00 to the end.
    */
    const result = offset.includes(':')
      ? offset
      : offset.replace(/([+-])(\d)$/, '$10$2:00');
    return result.replace('GMT', '');
  } catch (error) {
    return 'Invalid Timezone';
  }
}
